import { createRoot } from 'react-dom/client'
import {QueryClientProvider} from "@tanstack/react-query";
import {RouterProvider} from "react-router";
import "./services/http.js";
import {queryClient} from "./services/query-client.js";
import router from "./routes/router.js";
import "./index.css"
import  "./css/style-custom.css"
import {ToastContainer} from "react-toastify";

createRoot(document.getElementById('root')).render(
    <QueryClientProvider client={queryClient}>
        <ToastContainer className="toast-custom" />

        <RouterProvider router={router}/>
    </QueryClientProvider>
);
